import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { VehicleNote } from '../domain/note';
import { SessionService } from '@nw/ui-core-shared/services/session.service';
import { Store } from '@ngrx/store';
import { WatchlistApplicationState } from '../../store/watchlist-state';
import { WatchlistStoreData } from '../../store/watchlist-store-data';
import { HttpClient } from '@angular/common/http';

const baseEndpoint = '/api/watchlist';

@Injectable()
export class VehicleNoteService {

    private watchlistState: WatchlistStoreData;

    constructor(private httpClient: HttpClient,
                private sessionService: SessionService,
                private store: Store<WatchlistApplicationState>) {
        this.store.select(state => state.watchlistStoreData).subscribe(watchlistState => {
            this.watchlistState = watchlistState;
        });
    }

    updateNote(noteData: VehicleNote): Observable<VehicleNote> {
        const currentVehicleNote = this.watchlistState.vehicles.find(vehicle => vehicle.nwVehicleId === noteData.nwVehicleId).note;
        if (!currentVehicleNote && noteData.note !== '') {
            return this.addNewNote(noteData);
        } else if (currentVehicleNote && noteData.note !== '' && currentVehicleNote !== noteData.note) {
            return this.updateCurrentNote(noteData);
        } else if (currentVehicleNote && noteData.note === '') {
            return this.removeCurrentNote(noteData.nwVehicleId);
        } else {
            return Observable.of();
        }

    }

    private addNewNote(noteData: VehicleNote) {
        return this.httpClient.post(`${baseEndpoint}/${this.sessionService.getPrincipal().getUserId()}/vehicles/${noteData.nwVehicleId}/notes`, noteData)
            .map(res => res)
            .catch(err => {
                return Observable.throw(err);
            });
    }

    private updateCurrentNote(noteData: VehicleNote) {
        return this.httpClient.put(`${baseEndpoint}/${this.sessionService.getPrincipal().getUserId()}/vehicles/${noteData.nwVehicleId}/notes`, noteData)
            .map(res => res)
            .catch(err => {
                return Observable.throw(err);
            });
    }

    private removeCurrentNote(vehicleId: string) {
        return this.httpClient.delete(`${baseEndpoint}/${this.sessionService.getPrincipal().getUserId()}/vehicles/${vehicleId}/notes`)
            .map(() => {
                return {'nwVehicleId': vehicleId};
            })
            .catch(err => {
                return Observable.throw(err);
            });
    }

}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/shared/services/vehicle-note.service.ts